import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { RootStoreContext } from '_core/storeMobx/RootStore'
import { GoodsListItemCart } from '_core/components/GoodsListItemCart'
import { GoodsListItemShop } from '_core/components/GoodsListItemShop'

import { GoodsListItemModal } from '../GoodsListItemModal'


const RawGoodsListItem = observer((props) => {
  const { data, type, cartItemCount, close } = props

  const sale = !data.isSkeleton && data.amount.value < data.price.value

  const { cartStore } = useContext(RootStoreContext)
  
  const {
    config: { ROUTE_URL },
  } = useGlobal()

  const defaultGoodsProps = {
    data,
    sale,
    close,
    cartStore,
    goodsUrl: `${ROUTE_URL.PRODUCT}`,
  }

  return type === 'cart' ? (
    <GoodsListItemCart
      {...defaultGoodsProps}
      changeCount={(id, count) => cartStore.set(data, count)}
      removeFromCart={(id) => cartStore.set(data, 0)}
      count={cartItemCount}
    />
  ) : type === 'modal' ? (
    <GoodsListItemModal
      {...defaultGoodsProps}
      removeFromCart={(id) => cartStore.set(data, 0)}
      count={cartItemCount}
    />
  ) : (
    <GoodsListItemShop
      {...defaultGoodsProps}
      count={cartStore.getCount(data)}
      addToCart={(count) => {
        cartStore.add(data, count);
        cartStore.setVisible(true);
      }}
    />
  )
})

RawGoodsListItem.defaultProps = {
  type: 'list',
}

RawGoodsListItem.propTypes = {
  // self props
  cartItemCount: PropTypes.number,
  type: PropTypes.oneOf(['list', 'cart', 'modal']),
  data: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const GoodsListItem = withLang(RawGoodsListItem)
